import { render, staticRenderFns } from "./addskulist.vue?vue&type=template&id=0e75f75b&scoped=true"
import script from "./addskulist.vue?vue&type=script&lang=js"
export * from "./addskulist.vue?vue&type=script&lang=js"
import style0 from "./addskulist.vue?vue&type=style&index=0&id=0e75f75b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e75f75b",
  null
  
)

export default component.exports